import {OptionKey} from 'models/configuration/OptionModel'
import {TourKey} from 'models/configuration/TourModel'
import {TrackModel} from 'models/configuration/TrackModel'
import {RegistrationModel} from 'models/registration/RegistrationModel'
import {StepConfig, StepKey, StepModel} from 'models/registration/StepModel'
import {Memoize} from 'util/memoize'

export type TouringStepConfig = StepConfig

export class TouringStepModel extends StepModel {
	@Memoize()
	get key(): StepKey {
		return 'touring'
	}

	@Memoize()
	get tracks(): Array<TrackModel> {
		return this.registration.tracks.filter(track => track.tours.length > 0)
	}

	@Memoize()
	get isApplicable(): boolean {
		if (this.event.tours.length === 0) return false
		return this.registration.allSteps.details.shouldShowTours
	}

	@Memoize()
	get isReady(): boolean {
		return true
	}

	@Memoize()
	get tours(): Array<TourKey> {
		return this.registration.state.tours
	}

	// ----- State changes ----- //
	setTours(tours: Array<OptionKey>): RegistrationModel {
		return this.registration.update({tours})
	}
}
